import ApiClient from './ApiClient';

class ProjectMembers extends ApiClient {
  constructor() {
    super('members', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/members`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, { userId, roles }) {
    this.projectId = projectId;
    return super.create({ member: { user_id: userId, roles } });
  }

  update(projectId, id, { roles }) {
    this.projectId = projectId;
    return super.update(id, { member: { roles } });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectMembers();
